/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_PhotoInputs */

const en_fc_home_artcraft_photo = /** @type {(inputs: Fc_Home_Artcraft_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo editing`)
};

/**
* | output |
* | --- |
* | "Photo editing" |
*
* @param {Fc_Home_Artcraft_PhotoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_photo = /** @type {((inputs?: Fc_Home_Artcraft_PhotoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_PhotoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_photo(inputs)
});
export { fc_home_artcraft_photo as "fc.home.artcraft.photo" }